import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";

import AppRoutes from "./Routes";
import { RealtimeProvider } from "./realtime/RealtimeProvider";
import { ToastProvider } from "./components/ToastProvider";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { AuthProvider } from "./auth/AuthProvider";
import { BrandProvider } from "./brand/BrandProvider";
import { ThemeProvider } from "./theme/ThemeProvider";
import { queryClient } from "./api/queryClient";
import "./index.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary>
      <ThemeProvider>
      <AuthProvider>
        <QueryClientProvider client={queryClient}>
          <BrandProvider>
          <RealtimeProvider>
            <BrowserRouter>
              <ToastProvider>
                <AppRoutes />
              </ToastProvider>
            </BrowserRouter>
          </RealtimeProvider>
          </BrandProvider>
        </QueryClientProvider>
      </AuthProvider>
      </ThemeProvider>
    </ErrorBoundary>
  </StrictMode>,
);
